var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_003-floppy-disk",
    "data-name": "003-floppy-disk",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.93,
    height: 40.93,
    viewBox: "0 0 40.93 40.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1364",
    "data-name": "Group 1364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1363",
    "data-name": "Group 1363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M40.657,7.714,33.215.273A.929.929,0,0,0,32.558,0H3.721A3.725,3.725,0,0,0,0,3.721V37.209A3.725,3.725,0,0,0,3.721,40.93H37.209a3.725,3.725,0,0,0,3.721-3.721V8.372A.93.93,0,0,0,40.657,7.714ZM9.3,1.86H29.767V13.023a1.862,1.862,0,0,1-1.86,1.86H11.163a1.862,1.862,0,0,1-1.86-1.86ZM33.488,39.069H7.442V22.325H33.488Zm5.581-1.86a1.862,1.862,0,0,1-1.86,1.86h-1.86V21.4a.93.93,0,0,0-.93-.93H6.512a.93.93,0,0,0-.93.93V39.069H3.721a1.862,1.862,0,0,1-1.86-1.86V3.721a1.862,1.862,0,0,1,1.86-1.86H7.442V13.023a3.725,3.725,0,0,0,3.721,3.721H27.907a3.725,3.725,0,0,0,3.721-3.721V1.86h.545l6.9,6.9Z",
    fill: "#00868e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.cad4d00d76f4a816c33ec176fae47508.svg";
export { ForwardRef as ReactComponent };